import { render } from "./Tabs.vue?vue&type=template&id=28b39f2e&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=28b39f2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28b39f2e"

export default script